import { MetaDto, MetaRpc, MetaVacationTypeDto, MetaUserItemDto } from "rpc/meta";

export class Meta {

    private static _data: MetaData;

    public static async load(): Promise<MetaData> {
        var dto = await MetaRpc.get();
        this._data = this.parseDto(dto);
        return this._data;
    }

    public static get() {
        return this._data;
    }

    private static parseDto(dto: MetaDto): MetaData {
        var res = new MetaData(dto.userId, dto.userName, dto.email, dto.companyId, dto.companyName, EUserRole.findByName(dto.role), dto.vacationTypes, dto.users);

        return res;
    }


    private constructor() {

    }

}

export class MetaData {

    public constructor(
        public readonly userId: number,
        public readonly userName: string,
        public readonly email: string,
        public readonly companyId: number,
        public readonly companyName: string,
        public readonly userRole: EUserRole,
        public readonly vacationTypes: MetaVacationTypeDto[],
        public readonly users: MetaUserItemDto[]
    ) { }

}

export class EUserRole {

    public static readonly USER = new EUserRole("USER", "Co worker", 100);
    public static readonly HR = new EUserRole("HR", "HR assistant", 200);
    public static readonly ADMIN = new EUserRole("ADMIN", "Admin", 300);
    public static readonly OWNER = new EUserRole("OWNER", "Owner", 400);

    public static findByName(name: string) {
        return EUserRole[name];
    }

    public static values(): EUserRole[] {
        return [
            this.USER, this.HR, this.ADMIN, this.OWNER
        ];
    }

    public readonly name: string;
    public readonly title: string;
    public readonly level: number;

    private constructor(name: string, title: string, level: number) {
        this.name = name;
        this.title = title;
        this.level = level;
    }

}